/**
 *
 * Asynchronously loads the component for AppStore
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AppStore = lazyLoad(
  () => import('./index'),
  module => module.AppStore,
);
